import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  completePropertyProfilePageWrapper: {
    height: '100vh',
    width: '100%',
    maxWidth: '100vw',
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    overflow: 'hidden',
    position: 'relative',
    padding: '0 24px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '0 16px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 8px',
      gap: '16px',
    },
  },
  saveActionButton: {
    backgroundColor: theme.palette.button.secondary_bg,
    border: `1px solid ${theme.palette.button.secondary_border}`,
    color: theme.palette.button.secondary_fg,
    minWidth: '121px',
    height: '44px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      minWidth: '100px',
      fontSize: '14px',
      height: '40px',
    },
  },
  nextActionButton: {
    backgroundColor: theme.palette.button.primary_bg,
    border: `1px solid ${theme.palette.button.primary_border}`,
    color: theme.palette.button.primary_fg,
    minWidth: '74px',
    height: '44px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      minWidth: '60px',
      fontSize: '14px',
      height: '40px',
    },
  },
  completePropertyProfileContentWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    overflow: 'hidden',
    gap: '0',
    minHeight: 0,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      overflow: 'auto',
    },
  },
  stepsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '20%',
    minWidth: '200px',
    width: '325px',
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down('lg')]: {
      width: '25%',
      minWidth: '180px',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      flexDirection: 'row',
      overflowX: 'auto',
      overflowY: 'hidden',
      paddingRight: 0,
      paddingBottom: '8px',
    },
  },
  stepContainer: {
    display: 'flex',
    gap: '12px',
    alignContent: 'center',
    justifyContent: 'start',
    alignItems: 'center',
    height: '64px',
    maxHeight: '64px',
    borderRadius: '12px 0 0 12px',
    borderTop: `1px solid ${theme.palette.border.secondary}`,
    borderBottom: `1px solid ${theme.palette.border.secondary}`,
    borderLeft: `1px solid ${theme.palette.border.secondary}`,
    backgroundColor: theme.palette.background.gray_50,
    flexWrap: 'nowrap',
    padding: '20px 16px',
    cursor: 'pointer',
    minWidth: '325px',
    whiteSpace: 'nowrap',
    '& > *:nth-child()': {
      height: 'fit-content',
    },
    [theme.breakpoints.down('md')]: {
      borderRadius: '12px',
      border: `1px solid ${theme.palette.border.secondary}`,
      minWidth: '200px',
      flexShrink: 0,
    },
  },
  stepPageContainer: {
    flex: 1,
    height: '100%',
    backgroundColor: theme.palette.background.primary,
    borderRadius: '0 12px 12px 12px',
    border: '1px solid #EAECF0',
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      borderRadius: '12px',
      marginTop: '16px',
    },
  },
  stepName: {
    color: '#344054',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    minWidth: '258px',
    [theme.breakpoints.down('lg')]: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  stepItem: {
    position: 'relative',
    transition: 'all 0.3s ease',
    '&:hover': {
      '& $stepContainer': {
        backgroundColor: theme.palette.background.gray_100,
      },
    },
  },
  activeStep: {
    '& $stepContainer': {
      backgroundColor: theme.palette.background.brand_50,
      borderColor: theme.palette.border.brand_300,
      borderRight: 'none',
    },
    '& $stepName': {
      color: theme.palette.text.brand_700,
    },
  },
  completedStep: {
    '& $stepContainer': {
      borderColor: theme.palette.border.success_300,
    },
    '& $stepName': {
      color: theme.palette.text.success_700,
    },
  },
  checkmark: {
    color: theme.palette.text.success_700,
    fontSize: '18px',
    fontWeight: 700,
    marginLeft: 'auto',
  },
  titleWithPercentage: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
  },
  completionPercentage: {
    height: '28px',
    width: '54px',
    color: theme.palette.text.brand_700,
    backgroundColor: theme.palette.background.brand_50,
    border: `1px solid ${theme.palette.border.brand_200}`,
    borderRadius: '16px',
    padding: '4px 12px',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    textAlign: 'center',
  },
  breadcrumbActiveProperty: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px 8px',
    borderRadius: '6px',
    maxHeight: '28px',
    maxWidth: 'fit-content',
    backgroundColor: theme.palette.breadcrumbs.brand_bg_hover,
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    color: theme.palette.breadcrumbs.brand_fg_hover,
  },
  propertyMiniPreviewWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px',
  },
  propertyMiniPreview: {
    height: '73px',
    minWidth: '293px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '8px',
    border: `1px solid ${theme.palette.border.brand}`,
    backgroundColor: theme.palette.background.brand_50,
    borderRadius: '12px',
    padding: '12px',
  },
  propertyImageContainer: {
    height: '48px',
    width: '48px',
    minWidth: '48px',
    maxWidth: '48px',
    minHeight: '48px',
    maxHeight: '48px',
    overflow: 'hidden',
    borderRadius: '23px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
  },
  propertyMiniPreviewInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '2px',
    '& > *:nth-child(1)': {
      fontFamily: 'Inter',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 'normal',
      color: theme.palette.text.primary,
    },
    '& > *:nth-child(2)': {
      fontFamily: 'Inter',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      color: theme.palette.text.brand_secondary,
    },
    '& > *:nth-child(3)': {
      display: 'flex',
      gap: '2px',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Inter',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      color: theme.palette.text.tertiary,
    },
  },
  skeletonPulse: {
    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
    backgroundSize: '200% 100%',
    animation: '$pulse 1.5s ease-in-out infinite',
  },
  '@keyframes pulse': {
    '0%': {
      backgroundPosition: '200% 0',
    },
    '100%': {
      backgroundPosition: '-200% 0',
    },
  },
  breadcrumbSkeleton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 0',
    '& $skeletonBox': {
      borderRadius: '4px',
    },
  },
  propertyMiniPreviewSkeleton: {
    height: '73px',
    minWidth: '293px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '8px',
    backgroundColor: theme.palette.background.brand_50,
    border: `1px solid ${theme.palette.border.brand_50}`,
    borderRadius: '12px',
    padding: '12px',
  },
  propertyImageSkeleton: {
    height: '48px',
    width: '48px',
    minWidth: '48px',
    borderRadius: '23px',
    backgroundColor: '#f0f0f0',
  },
  propertyInfoSkeleton: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '6px',
    flex: 1,
  },
  skeletonBox: {
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
  },
}));
